import React from 'react';
import ReactApexChart from 'react-apexcharts';

const TrafficSourceChart = ({ data }) => {
  const leads = data?.total_percentage_current_month || 0;
  const nonLeads = data?.non_lead_percentage_current_month || 0;
  const isEmptyData = leads === 0 && nonLeads === 0;

  const chartData = {
    series: isEmptyData ? [100] : [leads, nonLeads],
    options: {
      chart: {
        type: 'donut',
      },
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: true,
              name: { show: !isEmptyData },
              value: {
                show: true,
                formatter: (val) => (isEmptyData ? '0%' : `${val}%`),
              },
              total: {
                show: isEmptyData,
                label: 'No Traffic',
                formatter: () => '0%',
              },
            },
          },
        },
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: false,
      },
      colors: isEmptyData ? ['#E0E0E0'] : ['#b94feb', '#f4543a'],
      fill: isEmptyData
        ? {
            type: 'discrete',
            pattern: {
              style: 'verticalLines',
              width: 6,
              height: 6,
              strokeWidth: 5,
            },
          }
        : {
            type: 'gradient',
            gradient: {
              shade: 'light',
              type: 'horizontal',
              gradientToColors: ['#b94feb', '#f4543a'],
            },
          },
      tooltip: {
        y: {
          formatter: function (val, context) {
            if (!context || !context.w || !context.w.globals) return `${val}%`;
            const label = context.w.globals.labels[context.seriesIndex] || '';
            return `${label}: ${val}%`;
          },
        },
      },
      states: {
        hover: {
          filter: {
            type: 'shadow',
            value: 0.1,
          },
        },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 250,
            },
          },
        },
      ],
      labels: isEmptyData ? ['No Data'] : ['Leads', 'Non-Leads'],
    },
  };

  const legendData = isEmptyData
    ? [{ label: 'No Traffic Data', color: '#E0E0E0' }]
    : [
        { label: 'Leads', color: '#b94feb' },
        { label: 'Non-Leads', color: '#f4543a' },
      ];

  return (
    <div className='d-flex align-items-center justify-content-center h-100'>
      <div style={{ width: '250px' }}>
        <ReactApexChart options={chartData.options} series={chartData.series} type='donut' height={250} />
      </div>
      <div className='ms-3'>
        {legendData.map((item, index) => (
          <div key={index} className='d-flex align-items-center mb-2'>
            <span
              style={{
                width: '12px',
                height: '12px',
                backgroundColor: item.color,
                borderRadius: '50%',
                display: 'inline-block',
                marginRight: '8px',
              }}
            ></span>
            <span>{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrafficSourceChart;
